"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportButton = void 0;
var _CSVExport = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/general/CSVExport.svg"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../button"));
var _checkbox = _interopRequireDefault(require("../checkbox"));
var _ellipsisTooltip = _interopRequireDefault(require("../ellipsis-tooltip"));
var _useConfig = require("../hooks/useConfig");
var _icon = _interopRequireDefault(require("../icon"));
var _modal = _interopRequireWildcard(require("../modal"));
var _tabs = _interopRequireDefault(require("../tabs"));
var _tooltip = _interopRequireDefault(require("../tooltip"));
var _typography = _interopRequireDefault(require("../typography"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ExportButton = props => {
  const {
    hidenAllRange,
    defaultRange = 'current',
    exportOpts,
    currentListParams = {},
    onExport,
    ...buttonProps
  } = props;
  const {
    locale: {
      Table: TableLocale
    }
  } = (0, _useConfig.useConfig)();
  const [{
    open,
    close
  }] = _modal.default.useModal();
  const Content = (0, _react.useCallback)(() => {
    const [range, setRange] = (0, _react.useState)(hidenAllRange ? 'current' : defaultRange);
    const [reqBody, setReqBody] = (0, _react.useState)(exportOpts.filter(i => i.defaultChecked).map(i => ({
      name: i.title,
      key: i.key
    })));

    //是否是全选
    const isAllActive = exportOpts.every(i => reqBody.some(r => r.key === i.key));

    //是否是全不选（都不算disabled的）
    const isAllUnactive = exportOpts.every(i => i.disabled || reqBody.every(r => r.key !== i.key));
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "table-export-content",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_typography.default, {
        level: "h6",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_tabs.default, {
          type: "toggle",
          activeKey: range,
          onChange: v => setRange(v),
          tabs: [{
            name: TableLocale.exportModal_current,
            key: 'current'
          }, {
            name: TableLocale.exportModal_all,
            hidden: hidenAllRange,
            key: 'all'
          }]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_typography.default, {
        level: "h6",
        title: TableLocale.exportModal_fields,
        extra: /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.default, {
          size: "s",
          checked: isAllActive,
          indeterminate: !isAllActive && !isAllUnactive,
          onChange: v => {
            if (v) {
              const v = exportOpts.map(i => ({
                name: i.title,
                key: i.key
              }));
              setReqBody(v);
            } else {
              const v = exportOpts.filter(i => i.disabled).map(i => ({
                name: i.title,
                key: i.key
              }));
              setReqBody(v);
            }
          },
          children: isAllActive ? TableLocale.exportModal_clear : TableLocale.exportModal_selectAll
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "fields-box",
          children: exportOpts.map(i => {
            const checked = reqBody.some(v => v.key === i.key);
            const onClick = () => {
              if (!i.disabled) {
                if (checked) {
                  const value = reqBody.filter(v => v.key !== i.key);
                  setReqBody(value);
                } else {
                  setReqBody([...reqBody, {
                    name: i.title,
                    key: i.key
                  }].sort((a, b) => exportOpts.findIndex(v => v.key === a.key) - exportOpts.findIndex(v => v.key === b.key)));
                }
              }
            };
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: (0, _classnames.default)('item', {
                ['item-active']: checked,
                ['item-disabled']: i.disabled
              }),
              onClick: onClick,
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_checkbox.default, {
                checked: checked,
                onChange: onClick,
                disabled: i.disabled,
                size: "s",
                shape: "circular"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ellipsisTooltip.default, {
                className: "name",
                children: i.title
              })]
            }, i.key);
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_modal.FooterButton, {
        okButtonText: TableLocale.exportModal_download,
        onCancel: close,
        okButtonProps: {
          disabled: !reqBody.length
        },
        onOk: async () => await onExport({
          ...currentListParams,
          ...(range === 'all' ? {
            pageNum: 0,
            pageSize: 0
          } : {}) //约定好的
        }, reqBody)
      })]
    });
  }, [props]);
  const openExportModal = (0, _react.useCallback)(() => {
    open({
      title: TableLocale.exportModal_title,
      closable: true,
      width: 764,
      okButtonText: null,
      cancelButtonText: null,
      content: /*#__PURE__*/(0, _jsxRuntime.jsx)(Content, {})
    });
  }, [props]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_tooltip.default, {
    title: TableLocale.exportButtonTip,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
        type: "general/CSVExport"
      }),
      size: "s",
      type: "normal",
      ...buttonProps,
      onClick: openExportModal
    })
  });
};
exports.ExportButton = ExportButton;